import {RoleAuthCustomerDto} from "./role-auth-customer.dto";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";

export class RoleAuthCustomerRegionDto extends DtoDetail{


    public roleAuthCustomerDto? : RoleAuthCustomerDto;
    public roleAuthCustomerDtoId : number;
    public roleAuthCustomerDtoName : string;
    public postalCode: string;

}